module.exports = __webpack_public_path__ + "static/gallery14-5bceb3efc20b39956325fce78dcfa0d9.png";